import { ButtonBase, Typography } from "@mui/material";
import { Add } from "@mui/icons-material";

interface Props {
  onClick: () => void;
  testId: string;
}

/** Replica `.mp-add`: botón punteado de ancho completo para agregar otra tarjeta de servicio. */
export const ButtonAddService = ({ onClick, testId }: Props) => (
  <ButtonBase
    onClick={onClick}
    data-testid={testId}
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "7px",
      width: "100%",
      height: 46,
      mt: 1.5,
      border: "1px dashed",
      borderColor: "tokens.borderStrong",
      borderRadius: "12px",
      color: "primary.dark",
      "&:hover": {
        borderStyle: "solid",
        borderColor: "primary.main",
        color: (theme) => theme.palette.primary.hover ?? theme.palette.primary.main,
      },
    }}
  >
    <Add sx={{ fontSize: 16 }} />
    <Typography component="span" variant="body2" sx={{ fontFamily: "Outfit", fontWeight: 500, color: "inherit" }}>
      Agregar servicio
    </Typography>
  </ButtonBase>
);
